import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import type { ButtonProps } from '@mui/material/Button';

export default function NoAccessViewActionRow({
  prefix,
  buttonLabel,
  buttonProps,
}: {
  prefix: string;
  buttonLabel: string;
  buttonProps: ButtonProps;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      useFlexGap
      gap={{ xs: 0, sm: 2 }}
      sx={{
        alignItems: 'center',
        justifyContent: { xs: 'center', sm: 'flex-start' },
        flexWrap: 'wrap',
      }}
    >
      <Typography
        variant='body2'
        color='text.secondary'
        sx={{
          display: 'inline-flex',
          textAlign: { xs: 'center', sm: 'left' },
        }}
      >
        {prefix}
      </Typography>
      <Button
        size={isMobile ? 'small' : 'medium'}
        variant='text'
        {...buttonProps}
      >
        {buttonLabel}
      </Button>
    </Stack>
  );
}
